import type { ServiceMiniEntity } from './ServiceMiniEntity'

export class ServiceResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<ServiceMiniEntity> | null
}
